import "jsoneditor/dist/jsoneditor.min.css";
import JSONEditor from 'jsoneditor/dist/jsoneditor.min.js';
import React from 'react';
import { uuidDate } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import SgiCtlComponent from './sgiBaseComp/SgiCtlComponent';
import { SgiEventHandler } from './SgiEventHandler';
import { getConstByKey } from "./sgiBaseComp/SgiCommon";

export default class SgiJsoneditor extends SgiCtlComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            dvId: uuidDate(6, "yyyyMMddhhmmssSSS"),
            data: this.props.data,
            options: {},
            inOutType: "json",//输入输出类型，string|json
        };
    }

    // 转换自身属性
    __AddAttribute() {
        let { parentModule, moduleDesc, objFct, type } = this.props;

        if (!moduleDesc) return;

        this.state.dvId = getConstByKey(this, moduleDesc.cId) || this.state.dvId || uuidDate(6, "yyyyMMddhhmmssSSS");
        this.state.inOutType = moduleDesc.inOutType || this.state.inOutType;

        let options = this.state.options = {};
        for (const key in moduleDesc) {
            if (key.substr(0, 4) === "opt_" && moduleDesc[key] !== undefined) {
                options[key.substring(4)] = moduleDesc[key];
            }
        }

        // 取data
        const bdInst = getConstByKey(this, moduleDesc.bdInst);
        this.state.insName = bdInst;
        if (bdInst && objFct) this.state.data = objFct.get(bdInst);

        // 自定义option
        let getOption = moduleDesc.options;
        let $getOption;
        if (getOption) {
            try {
                $getOption = new Function("module", "objFct", getOption);
                if ($getOption) {
                    let cstmOptions = $getOption(this, objFct);
                    if (cstmOptions) Object.assign(options, cstmOptions);
                }
            } catch (error) {
                sgiLogger.eventErr(error);
            }
        }
    }

    // 绑定事件
    __bindEvent() {
        let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        let { _props, _class, options, insName, inOutType } = this.state;
        let { functions } = this.data;

        // options.onChange = SgiEventHandler.onJsoneditorChange.bind(this, this.state.editor);
        options.onChange = () => {
            let editor = this.state.editor;
            let json = editor.get();
            let text = editor.getText();
            this.state.data = inOutType === "string" ? text : json;
            if (insName && objFct) objFct.set(insName, inOutType === "string" ? text : json);
            SgiEventHandler.onJsoneditorChange.call(this, this.state.editor, text, json);
        };

        if (!moduleDesc || type == 'dnd') return;

        //onchange
        var chgLsn = moduleDesc.chgLsn; // 用户自定义修改事件
        if (chgLsn) {
            var $chgLsn;
            try {
                $chgLsn = new Function("module", "editor", "objFct", "text", "json", chgLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onChange = $chgLsn;
        }
    }

    // 渲染
    __render = () => <div id={this.state.dvId} {...this.state._props} />

    refreshByData(data) {
        this.state.data = data;
        if (typeof data === "string") this.state.editor.setText(data);
        else this.state.editor.set(data);
    }

    refresh = () => {
        let bdInst = this.state.insName;
        let objFct = this.props.objFct;
        let data = (bdInst && objFct) ? objFct.get(bdInst) : null;
        this.refreshByData(data);
    }

    // 暴露主要接口
    getJson = () => this.state.editor.get();
    getText = () => this.state.editor.getText();
    setJson = (json) => this.state.editor.set(json);
    setText = (text) => this.state.editor.setText(text);

    componentDidMount() {
        let container = document.getElementById(this.state.dvId);
        let options = this.state.options;
        let data = this.state.data;
        if (typeof data === "string") data = JSON.parse(data);
        let editor = new JSONEditor(container, options, data);
        this.state.editor = editor;
    }
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiJsoneditor.js